<template>
    <div class="date-time-select" @click="restartTime">
        <div class="input go" v-if="isMobile" @click="showOrderTime = true" :style="inputStyle">
            {{ timeTitle }}
            <img v-show="!isAlignLeft" src="@/assets/img/next-green.svg">
        </div>
        <div class="select" v-else>
            <select v-model="day" :style="selectStyle">
                <option v-for="val in days" :value="val.date" :key="val.date">{{ val.value }}</option>
            </select>
            <select class="time" v-model="time" :style="selectStyle">
                <option v-for="val in times" :value="val.date" :key="val.date">{{ val.value }}</option>
            </select>
        </div>
        <order-time v-if="showOrderTime" :selected="value" :dates="dates" @onDone="setTime"/>
    </div>
</template>

<script>
    import OrderTime from './order/SetOrderTime';
    import * as apis from '../../apis';
    import mTimezone from 'moment-timezone';
    import moment from 'moment';

    export default {
        name: 'DateTimeSelect',
        components: {
            'order-time': OrderTime,
        },
        props: {
           value: {
               default: {},
               required: true,
           },
           isSetMode: {
               default: false,
           },
           isAlignLeft: {
              default: false,
           },
           fontSize: {
               default: '14px',
           },
        },
        model: {
            prop: 'value',
            event: 'input',
        },
        data() {
            return {
                showOrderTime: false,
                timeTitle: '馬上出發',
                day: null,
                time: null,
                dates: {},
                loading: true,
            }
        },
        computed: {
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
            selectStyle() {
                return {
                    'text-align-last': this.isAlignLeft ? 'left' : 'right',
                }
            },
            inputStyle() {
                return {
                    'justify-content': this.isAlignLeft ? 'flex-start' : 'flex-end',
                    'text-align': this.isAlignLeft ? 'left' : 'right',
                    'font-size': this.fontSize,
                }
            },
            reservedAt() {
                return {
                    day: this.day,
                    time: this.time,
                }
            },
            days() {
                if (this.loading) {
                    return [];
                }

                let indexOffset = this.isSetMode ? 1 : 0;
                let days =  Object.keys(this.dates).map((key, index) => {
                    let date = moment(key);
                    let title = '';
                    if (index === (0 - indexOffset)) {
                        title = '今天，';
                    }

                    if (index === (1 - indexOffset)) {
                        title = '明天，';
                    }

                    if (index === (2 - indexOffset)) {
                        title = '後天，';
                    }

                    return {
                        date: key,
                        value: title + date.format('MM/DD')
                    }
                });

                if (! days.length) {
                    days = [{date: this.today.format('YYYY-MM-DD'), value: this.today.format('今天，MM/DD')}]
                }

                return days;
            },
            times() {
                if (this.loading) {
                    return [];
                }

                let date = this.dates[this.day] || [];
                let times = date.map(time => {
                    time = moment(time);
                    return {
                        date: time.format('HH:mm'),
                        value: time.format('HH:mm'),
                    }
                });

                if (Object.keys(this.dates)[0] === this.day) {
                    times = [{date: 'now', value: '馬上出發'}].concat(times);
                }

                let index = times.findIndex(time => {
                    return time.date === this.time;
                });

                if (index < 0 && times.length) {
                    this.time = times[0].date === 'now' ? times[0].date : times[Math.max(Math.floor(times.length/2), 0)].date;
                }

                return times;
            },
        },
        methods: {
            restartTime() {
                apis.getReserve().then(res => {
                    this.setDates(res.data.dates);
                });
            },
            setTime(day, time) {
                this.showOrderTime = false;
                if (! day) {
                    return;
                }

                if (time === 'now') {
                    this.$emit('input', null);
                    this.timeTitle = '馬上出發';
                    return ;
                }

                this.timeTitle = `${day.value} ${time}`;
                this.$emit('input', `${day.date} ${time}:00`);
            },
            init() {
                if (this.value === null) {
                    let timezone = mTimezone().tz('Asia/Taipei');
                    let time = moment(timezone);
                    this.day = this.isSetMode ? time.add(1, 'days').format('YYYY-MM-DD') : time.format('YYYY-MM-DD');
                    this.time = this.isSetMode ? '12:00' : 'now';
                    return ;
                }
                let data = this.value.split(' ');

                this.day = data[0];
                this.time = data[1].slice(0,5);
            },
            setDates(dates) {
                if (! this.isSetMode) {
                    this.dates = dates;
                    return;
                }

                let names = Object.getOwnPropertyNames(dates);
                if (! names.length) {
                    this.dates = dates;
                    return;
                }

                delete dates[names[0]];
                this.dates = dates;
            },
        },
        created() {
            apis.getReserve().then(res => {
                this.setDates(res.data.dates);
                this.init();
                this.loading = false;
            });
        },
        watch: {
            reservedAt() {
                this.setTime({
                    'date': this.reservedAt.day,
                    'value': this.reservedAt.day
                }, this.reservedAt.time);
            },
            value() {
                this.init();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .date-time-select {
        .select {
            height: 21px;
        }
        .input {
            display: flex;
            align-items: center;
            color: rgba(51,153,51,1);
            font-weight: 500;
            line-height: 20px;
        }
    }
    select {
        border: none;
        background: none;
        font-size: 16px !important;
        color: rgba(51,153,51,1);
        height: 20px !important;
        min-width: 114px;

        option {
            height: 20px;
        }

        &.time {
            min-width: 88px;
        }
    }
</style>
